import { Reducer } from 'redux';
import { MachineHistory } from "models/MachineHistory";
import { MachineDefect } from "models/MachineDefect";
import { IMachineHistoryActions, MachineHistoryActionType } from "redux/actions/machines/MachineHistoryActions";
import { MachineDefectActionType } from "redux/actions/machines/MachineDefectActions";

const initialState: MachineHistory[] | null = null;
export const machineHistoriesReducer: Reducer<MachineHistory[] | null, IMachineHistoryActions> =
    (state = initialState, action) => {
        switch (action.type) {
            case MachineHistoryActionType.FETCH_MACHINEHISTORIES_SUCCESS:
                {
                    return action.returnPayload as MachineHistory[];
                }
            case MachineHistoryActionType.ADD_MACHINEHISTORY_SUCCESS:
                {
                    let newMachineHistorys = [...state!];
                    newMachineHistorys.push({ ...action.returnPayload } as MachineHistory)
                    return newMachineHistorys;
                }
            case MachineHistoryActionType.EDIT_MACHINEHISTORY_SUCCESS:
            case MachineHistoryActionType.DELETE_MACHINEHISTORY_SUCCESS:
                {
                    let newMachineHistories = [...state!];
                    const updatedMachineHistory = { ...action.returnPayload } as MachineHistory;
                    newMachineHistories = newMachineHistories.map(nm => nm.id === updatedMachineHistory.id ? updatedMachineHistory : nm);
                    return newMachineHistories;
                }
            case MachineDefectActionType.DELETE_MACHINEDEFECT_SUCCESS:
                {
                    // the defect is archived, keep the histories that list it in sync
                    if (!state) return state;
                    const archivedDefect = action.returnPayload as unknown as MachineDefect;
                    return state.map(mh => mh.machineDefects?.some(md => md.id === archivedDefect.id)
                        ? { ...mh, machineDefects: mh.machineDefects.map(md => md.id === archivedDefect.id ? archivedDefect : md) }
                        : mh);
                }
            default:
                return state;
        }
    };
